import Swiper, { Autoplay, Pagination } from 'swiper'
import { mdBreakpoint } from "../utils/breakpoints";

Swiper.use([Autoplay, Pagination]);

function initProducersCarousels() {

  const producersSwipers = Array.from(document.querySelectorAll('.js-producers-swiper'));

  producersSwipers.forEach(producersSwiper => {

    if (producersSwiper.classList.contains('-carousel-mobile') || producersSwiper.classList.contains('-carousel-desktop')) {

      let swiper = Swiper;
      let swiperInitialised = false;
      const paginationEl = producersSwiper.querySelector('.js-producers-pagination');

      const initSwiper = () => {
        swiperInitialised = true;

        swiper = new Swiper(producersSwiper, {
          loop: false,
          speed: 800,
          grabCursor: true,
          slidesPerView: 1,
          autoplay: {
            delay: 8000
          },
          watchOverflow: true,
          pagination: {
            el: paginationEl,
            clickable: true,
          },
          breakpoints: {
            576: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 3,
            }
          }
        });
      };

      const destroySwiper = () => {
        swiper.destroy();
        paginationEl.style.display = "none";
        swiperInitialised = false;
      };

      //Invoke on page load
      if (mdBreakpoint.matches &&
        swiperInitialised === false &&
        producersSwiper.classList.contains('-carousel-desktop')
      ) {
        initSwiper();
      } else if (!mdBreakpoint.matches &&
        swiperInitialised === false &&
        producersSwiper.classList.contains('-carousel-mobile')
      ) {
        initSwiper();
      }

      //Init or destroy after resize
      const initOrDestroy = () => {

        //Check if swiper should be destroyed
        if (mdBreakpoint.matches &&
          swiperInitialised === true &&
          !producersSwiper.classList.contains('-carousel-desktop')
        ) {
          destroySwiper()
        }
        else if (!mdBreakpoint.matches &&
          swiperInitialised === true &&
          !producersSwiper.classList.contains('-carousel-mobile')
        ) {
          destroySwiper()
        }

        //Check if swiper should be initialised
        if (mdBreakpoint.matches &&
          swiperInitialised === false &&
          producersSwiper.classList.contains('-carousel-desktop')
        ) {
          initSwiper();
          paginationEl.style.display = "flex";
          swiperInitialised = true;
        }
        else if (!mdBreakpoint.matches &&
          swiperInitialised === false &&
          producersSwiper.classList.contains('-carousel-mobile')
        ) {
          initSwiper();
          paginationEl.style.display = "flex";
          swiperInitialised = true;
        }
      };

      const invokeAfterResize = () => {
        let rtime;
        let timeout = false;
        const timeoutDuration = 200;

        window.addEventListener('resize', () => {
          rtime = new Date();
          if (timeout === false) {
            timeout = true;
            setTimeout(resizeEnd, timeoutDuration)
          }
        });

        const resizeEnd = () => {
          if (new Date() - rtime < timeoutDuration) {
            setTimeout(resizeEnd, timeoutDuration)
          } else {
            timeout = false;
            initOrDestroy()
          }
        }
      };
      invokeAfterResize()

    }
  })
}
initProducersCarousels();
